/**
 * @generated SignedSource<<331db547c854d7d1a982c5b09d088db6>>
 * @relayHash 040a6b2851053e2c9769475ef269bf98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dc78c1e9d68a31099e920cad6d459b318b00f47fa6ae79a4449170b60ff69d4f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceTemplateVariableInput = {
  key: string;
  value?: string | null | undefined;
};
export type VariableInputDrawerComponentUpdateInstanceMutation$variables = {
  pageAri: string;
  spaceKey?: string | null | undefined;
  templateId?: string | null | undefined;
  title?: string | null | undefined;
  variables?: ReadonlyArray<ConfluenceTemplateVariableInput | null | undefined> | null | undefined;
};
export type VariableInputDrawerComponentUpdateInstanceMutation$data = {
  readonly confluence_updateInstance: {
    readonly content: {
      readonly id: string | null | undefined;
      readonly links: {
        readonly editui: string | null | undefined;
      } | null | undefined;
      readonly metadata: {
        readonly simple: {
          readonly isFabric: boolean | null | undefined;
        } | null | undefined;
      };
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
      readonly subType: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type VariableInputDrawerComponentUpdateInstanceMutation = {
  response: VariableInputDrawerComponentUpdateInstanceMutation$data;
  variables: VariableInputDrawerComponentUpdateInstanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "variables"
},
v5 = [
  {
    "kind": "Literal",
    "name": "expand",
    "value": "metadata.simple.isFabric,space,version"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "title"
              },
              {
                "kind": "Variable",
                "name": "spaceKey",
                "variableName": "spaceKey"
              },
              {
                "kind": "Variable",
                "name": "variables",
                "variableName": "variables"
              }
            ],
            "kind": "ObjectValue",
            "name": "context"
          },
          {
            "kind": "Variable",
            "name": "templateId",
            "variableName": "templateId"
          }
        ],
        "kind": "ObjectValue",
        "name": "contentBlueprintSpec"
      },
      {
        "kind": "Literal",
        "name": "contentStatus",
        "value": "DRAFT"
      },
      {
        "kind": "Literal",
        "name": "nextVersion",
        "value": 1
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  {
    "kind": "Variable",
    "name": "pageAri",
    "variableName": "pageAri"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        (v6/*: any*/)
      ]
    },
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "editui"
        }
      ]
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentMetadata_SimpleContentMetadataProvider_simple",
          "kind": "LinkedField",
          "name": "simple",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFabric"
            }
          ]
        }
      ]
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "message"
},
v9 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "VariableInputDrawerComponentUpdateInstanceMutation",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "ConfluenceUpdateInstancePayload",
        "kind": "LinkedField",
        "name": "confluence_updateInstance",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "VariableInputDrawerComponentUpdateInstanceMutation",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "ConfluenceUpdateInstancePayload",
        "kind": "LinkedField",
        "name": "confluence_updateInstance",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "040a6b2851053e2c9769475ef269bf98",
    "id": "dc78c1e9d68a31099e920cad6d459b318b00f47fa6ae79a4449170b60ff69d4f",
    "metadata": {},
    "name": "VariableInputDrawerComponentUpdateInstanceMutation",
    "operationKind": "mutation",
    "text": "mutation VariableInputDrawerComponentUpdateInstanceMutation($pageAri:ID!,$templateId:String,$title:String,$spaceKey:String,$variables:[ConfluenceTemplateVariableInput]){confluence_updateInstance(pageAri:$pageAri,input:{contentBlueprintSpec:{templateId:$templateId,context:{name:$title,spaceKey:$spaceKey,variables:$variables}},contentStatus:DRAFT,nextVersion:1},expand:\"metadata.simple.isFabric,space,version\"){content{id,type,title,subType,space{key,id},links{editui},metadata{simple{isFabric}}},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "261540ed3b67aab287eaac9752045356";

export default node;
